export default __webpack_public_path__ + "static/media/belt_of_the_vanguard.348b0cf3.jpg";